import { render, staticRenderFns } from "./RankingInfoBox.vue?vue&type=template&id=456e787d&scoped=true"
import script from "./RankingInfoBox.vue?vue&type=script&lang=js"
export * from "./RankingInfoBox.vue?vue&type=script&lang=js"
import style0 from "./RankingInfoBox.vue?vue&type=style&index=0&id=456e787d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e787d",
  null
  
)

export default component.exports